// extracted by mini-css-extract-plugin
export var deleteCard = "styles-module--deleteCard--3uBvW";
export var deleteCardContent = "styles-module--deleteCardContent--1wWkf";
export var deleteCardSpacer = "styles-module--deleteCardSpacer--2-O91";
export var deleteCardButton = "styles-module--deleteCardButton--2rPQh";
export var noWrapButton = "styles-module--noWrapButton--35DEz";
export var cardText = "styles-module--cardText--2Jf4a";